export class RecoveryPointData {
    'backupId';
    'region';
    'creationTime';
    'lifecycle';
    'type';
    'size';
    'tags';
    'resourceType';
    'kmsKeyId';
    'ownerId';
    'resourceArn';
    'progressPercent';
    'sourceBackupId';
    'sourceBackupRegion';
    'failureMessage';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupId",
            "baseName": "backupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "creationTime",
            "baseName": "creationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lifecycle",
            "baseName": "lifecycle",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "size",
            "baseName": "size",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "kmsKeyId",
            "baseName": "kmsKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "ownerId",
            "baseName": "ownerId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceArn",
            "baseName": "resourceArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "progressPercent",
            "baseName": "progressPercent",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceBackupId",
            "baseName": "sourceBackupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceBackupRegion",
            "baseName": "sourceBackupRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "failureMessage",
            "baseName": "failureMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RecoveryPointData.attributeTypeMap;
    }
    constructor() {
    }
}
